import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-thumbnail',
	templateUrl: './thumbnail.component.html',
	styleUrls: ['./thumbnail.component.scss'],
	standalone: true,
	imports: [CommonModule, MatIconModule],
})
export class ThumbnailComponent implements OnInit, OnDestroy {
	@Input() src: string = '';
	@Input() alt: string = '';
	@Input() maxRetries: number = 5;
	@Input() retryIntervalBase: number = 1000;
	@Input() customClass: string = '';
	@Input() customStyle: any = {};

	currentRetry: number = 0;
	imageState: 'loading' | 'loaded' | 'error' | 'retrying' = 'loading';
	private retryTimeoutId: any;

	ngOnInit() {
		if (this.src) {
			this.loadImage();
		} else {
			this.imageState = 'error';
		}
	}

	ngOnDestroy() {
		if (this.retryTimeoutId) {
			clearTimeout(this.retryTimeoutId);
		}
	}

	onImageError() {
		if (this.currentRetry < this.maxRetries) {
			this.currentRetry++;
			const retryDelay = this.retryIntervalBase * this.currentRetry;

			this.retryTimeoutId = setTimeout(() => {
				this.loadImage();
			}, retryDelay);
		} else {
			this.imageState = 'error';
		}
	}

	private loadImage() {
		this.imageState = this.currentRetry === 0 ? 'loading' : 'retrying';

		const img = new Image();
		img.onload = () => {
			this.imageState = 'loaded';
		};

		img.onerror = () => {
			if (this.currentRetry < this.maxRetries) {
				this.currentRetry++;
				const retryDelay = this.retryIntervalBase * this.currentRetry;

				this.retryTimeoutId = setTimeout(() => {
					this.loadImage();
				}, retryDelay);
			} else {
				this.imageState = 'error';
			}
		};

		img.src = this.src;
	}
}
